import { type BriefContent, type BriefNotSettled, renderRichText } from '@sigora/domain';

import { BRIEF_HEADINGS, NOT_SETTLED_COPY } from '../brief-copy.ts';

/**
 * What a Not settled entry says is unsettled: the synthesis's words for an `unsettled` one, and the
 * kind's own sentence for a research question nobody asked or answered, which the Brief stores
 * without words so no synthesis can soften it.
 */
export const notSettledLine = (entry: BriefNotSettled): string =>
  entry.kind === 'unsettled' ? renderRichText(entry.what ?? []) : NOT_SETTLED_COPY[entry.kind];

/** The Not settled list under the Recommendation, each entry with the follow-up it suggests. */
export const NotSettledList = ({
  entries,
  cards,
}: {
  entries: BriefContent['recommendation']['not_settled'];
  cards: BriefContent['evidence']['cards'];
}) => {
  if (entries.length === 0) {
    return null;
  }

  return (
    <>
      <h3>{BRIEF_HEADINGS.notSettled}</h3>
      <ul className="brief-list brief-not-settled">
        {entries.map((entry) => {
          const rqText =
            entry.rq_id === null
              ? null
              : (cards.find((card) => card.rq_id === entry.rq_id)?.rq_text ?? null);

          return (
            <li key={entry.id} data-test-id="brief-not-settled-item" data-kind={entry.kind}>
              {rqText !== null && (
                <p className="brief-not-settled-rq" data-test-id="brief-not-settled-rq">
                  {rqText}
                </p>
              )}
              <p data-test-id="brief-not-settled-what">{notSettledLine(entry)}</p>
              <p className="brief-meta" data-test-id="brief-not-settled-follow-up">
                {renderRichText(entry.follow_up)}
              </p>
            </li>
          );
        })}
      </ul>
    </>
  );
};
